<template>
       <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Tema 1: Teorías del desarrollo">
                <div class="container-fluid margen_principal">
                    <div class="row">
                        <div class="col-xl-5 col-lg-5 col-12">
                            <h2>1. Teorías del desarrollo</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-12">
                           <p>Después de identificar las principales teorías que exponen los argumentos sobre los procesos de adquisición del lenguaje, en la presente unidad se describirán aquellas que buscan explicar cómo han sido los procesos de desarrollo en los niños y niñas. En este orden, devienen algunas tesis que centran su objeto de estudio en el desarrollo, visto desde la psicología evolutiva y cognitiva. Algunos de los planteamientos que se abordarán serán los conceptos de niñez, etapas y estadios de desarrollo, cambios lingüísticos, físicos y de pensamiento en los niños y niñas, estadios críticos y diversas nociones sobre los cambios en los seres humanos en los primeros años. En ese sentido, identificar cuál ha sido la trayectoria del desarrollo permitirá complementar los ciclos y teorías sobre la adquisición de la lengua, con una visión general sobre los procesos que maduran en los seres humanos en los primeros años de vida. Las referencias obligadas que se utilizarán en este trabajo, serán los aportes en materia de desarrollo de Piaget y Vygotsky.</p>
                        </div>
                    </div>
                    <div class="row mt-3 mb-2">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-xl-4 col-lg-4 col-12 offset-xl-4 offset-lg-4">
                                    <audio controls="" class="w-100" controlslist="nodownload">
                                         <source src="recursos/audio/au_u2_INLIN_slide9.mp3" type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'Tema1',
    mounted(){
        SwiperController(),
        document.title = this.$route.meta.title
    }
}
</script>